import { Loader2 } from 'lucide-react'

import { cn } from '@/app/utils/cn'
import { StoreQrCode } from '@/view/components/StoreQrCode'
import { useDownloadAppController } from './useDownloadAppController'

export function DownloadApp() {
  const { appName, isRedirecting, isError, isDesktop, appleUrl, googleUrl } =
    useDownloadAppController()

  const title = appName ? `Baixe o ${appName}` : 'Baixe o aplicativo'

  if (isRedirecting) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gray-50 px-6 text-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm font-medium text-gray-600">
          Abrindo a loja de aplicativos…
        </p>
      </div>
    )
  }

  const stores = [
    appleUrl && {
      url: appleUrl,
      badge: '/apple_badge.svg',
      label: 'Baixar na App Store',
      name: 'App Store',
    },
    googleUrl && {
      url: googleUrl,
      badge: '/google_badge.svg',
      label: 'Disponível no Google Play',
      name: 'Google Play',
    },
  ].filter(Boolean) as {
    url: string
    badge: string
    label: string
    name: string
  }[]

  const subtitle = isDesktop
    ? 'Aponte a câmera do seu celular para o QR Code da sua loja.'
    : 'Escolha a loja de acordo com o seu celular.'

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-gray-50 px-6 text-center">
      <div>
        <h1 className="text-xl font-bold text-gray-900">{title}</h1>
        <p className="mt-2 text-sm text-gray-500">{subtitle}</p>
      </div>

      {stores.length > 0 ? (
        <div
          className={cn(
            'flex w-full flex-col items-center gap-6',
            isDesktop
              ? 'max-w-2xl sm:flex-row sm:items-start sm:justify-center'
              : 'max-w-xs gap-3',
          )}
        >
          {stores.map((store) => (
            <div
              key={store.url}
              className="flex w-full max-w-xs flex-col items-center gap-3"
            >
              <a
                href={store.url}
                rel="noopener noreferrer"
                aria-label={store.label}
                className="w-full"
              >
                <img
                  src={store.badge}
                  alt={store.label}
                  className="mx-auto h-14 w-auto"
                />
              </a>

              {isDesktop && (
                <StoreQrCode
                  value={store.url}
                  caption={`Escaneie para abrir a ${store.name}.`}
                />
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="max-w-xs text-sm text-red-600">
          {isError
            ? 'Não foi possível carregar os links de download. Tente novamente mais tarde.'
            : 'Os links de download ainda não estão disponíveis para este parceiro.'}
        </p>
      )}
    </div>
  )
}
